/**
 * アコーディオン
 * 「.js__accordion」に対して処理をする
 * 
<li class="js__accordion">
  <a class="js__accordionTrigger">botann</a>
  </a>
  <ul class="js__accordionTarget">
      ...
  </ul>
</li>
 */

import { functions } from "../../modules/functions";

export module AccordionModule {
  export class Service {
    constructor() {
      document.addEventListener('readCompleteAction', () => {
        Service.accordionSetEvent();
      });
    }

    public static accordionSetEvent() {
      const $elements = document.querySelectorAll('.js__accordion .js__accordionTrigger');
      if ($elements) {
        $elements.forEach($element => {
          const $parent = $element.closest('.js__accordion');
          if ($parent && !$parent.classList.contains('js__accordion--isActive')) {
            const $target = $element.closest('.js__accordion')?.querySelector<HTMLElement>('.js__accordionTarget');
            if ($target) {
              $target.style.display = 'none';
            }
          }
          $element.addEventListener('click', ($event) => {
            const $self = $element;
            const $parent = $self.closest('.js__accordion');
            if ($parent) {
              const $target = $parent.querySelector<HTMLElement>('.js__accordionTarget');
              if ($target) {
                $parent.classList.toggle('js__accordion--isActive');
                if ($parent.classList.contains('js__accordion--isActive')) {
                  functions.slideDown($target);
                } else {
                  functions.slideUp($target);
                }
              }
            }
          });
        });
      }
    }
  }
}